import type { HotmartProductMapping } from "../services/chatbotV2/chatbotV2Service";

export const HOTMART_MEMBERS_IMPORT_URL = "https://app.hotmart.com/membership/list";

export function parseClubSubdomainFromUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  const raw = url.trim();
  if (!raw) return null;
  const normalized = raw.includes("://") ? raw : `https://${raw.replace(/^\/+/, "")}`;
  try {
    const parsed = new URL(normalized);
    const host = parsed.hostname.toLowerCase();
    if (host.endsWith(".club.hotmart.com")) {
      const slug = host.slice(0, -".club.hotmart.com".length);
      return slug || null;
    }
    const parts = parsed.pathname.split("/").filter(Boolean);
    const clubIndex = parts.findIndex((part) => part.toLowerCase() === "club");
    if (clubIndex >= 0 && clubIndex + 1 < parts.length) {
      const candidate = parts[clubIndex + 1].trim().toLowerCase();
      if (/^[a-z0-9][a-z0-9-]{1,62}[a-z0-9]$/.test(candidate)) {
        return candidate;
      }
    }
  } catch {
    return null;
  }
  return null;
}

export function clubPublicUrlFromMapping(mapping: HotmartProductMapping): string {
  const value = mapping.metadata_json?.club_public_url;
  return typeof value === "string" ? value : "";
}

export function buildHotmartClubMappingPatch(
  mapping: HotmartProductMapping,
  patch: { club_public_url?: string; club_subdomain?: string }
): Partial<Pick<HotmartProductMapping, "club_subdomain" | "is_active">> & {
  metadata_json?: Record<string, unknown>;
  club_public_url?: string;
} {
  const metadata = { ...(mapping.metadata_json || {}) };
  const next: {
    club_subdomain?: string;
    metadata_json?: Record<string, unknown>;
    club_public_url?: string;
  } = {};

  if (patch.club_public_url !== undefined) {
    const trimmed = patch.club_public_url.trim();
    if (trimmed) {
      metadata.club_public_url = trimmed;
      next.club_public_url = trimmed;
      const parsed = parseClubSubdomainFromUrl(trimmed);
      if (parsed) {
        next.club_subdomain = parsed;
      }
    } else {
      delete metadata.club_public_url;
      next.club_public_url = "";
    }
  }

  if (patch.club_subdomain !== undefined) {
    next.club_subdomain = patch.club_subdomain.trim() || undefined;
  }

  next.metadata_json = metadata;
  return next;
}

export function hotmartAccessCaseStatusLabel(status: string): string {
  switch (status) {
    case "open":
      return "Abierto";
    case "in_progress":
      return "En progreso";
    case "resolved":
      return "Resuelto";
    case "dismissed":
      return "Descartado";
    default:
      return status;
  }
}
